import React, {useContext, useState } from 'react';
import {LocalizationContext} from '../../contexts';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import './index.scss';

export default function DeleteFormItem(props) {
    const [localization] = useContext(LocalizationContext);
    const {labels} = localization;
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const openDeleteDialog = () =>{
      setShowDeleteDialog(true);
    }

    const closeDeleteDialog = () =>{
      setShowDeleteDialog(false);
    }

    const handleDeleteClick = () => {
      props.handleDeleteClick(props.itemIdToDelete, props.type);
      closeDeleteDialog();
    };

    return (
        <span className="form-item__delete-wrapper">
          {showDeleteDialog && <Dialog onClose={closeDeleteDialog} title={false} >
            <p>{labels.pagesManagement.forms.delete_item}</p>
            <DialogActionsBar>
                <button className="k-button k-primary" onClick={handleDeleteClick}>{labels.pagesManagement.forms.delete}</button>
                <button className="k-button" onClick={closeDeleteDialog}>{labels.pagesManagement.forms.cancel}</button>
            </DialogActionsBar>
        </Dialog>}
        <button className="form-item__delete k-icon k-i-delete" onClick={() => openDeleteDialog()}></button>
      </span>
    );
};